/**
 * dispatch вынесен сюда, чтобы не привязывать superagent к redux
 */
type AnyFunction = (...args: any[]) => void;

// eslint-disable-next-line import/no-mutable-exports
export let dispatch: AnyFunction | null = null; // thunks support is required

export const registerDispatch = (globalDispatch: AnyFunction) => {
  dispatch = globalDispatch;
};
